import {
  Box,
  Chip,
  IconButton as MuiIconButton,
  type IconButtonProps,
  Toolbar as MuiToolbar,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const FULL_APP_BAR_MIN_WIDTH = 1440;
export const GET_UPDATES_LABEL_MIN_WIDTH = 1100;

export const Root = styled(Box)(() => ({
  flexGrow: 1,
}));

export const Wrapper = styled(Box)<{ gap?: string }>(() => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
}));

export const NavRow = styled(Wrapper)(({ theme }) => ({
  width: "100%",
  gap: "1.25rem",

  [theme.breakpoints.down(FULL_APP_BAR_MIN_WIDTH)]: {
    gap: "0.75rem",
  },
}));

const NAV_ITEM_GAP = 18;
const NAV_ITEM_PADDING_X = 4;
const NAV_ICON_GAP = 4;

export const Nav = styled(Wrapper)(() => ({
  marginRight: "auto",
  gap: `${NAV_ITEM_GAP - NAV_ITEM_PADDING_X * 2}px`,
}));

export const IconButtons = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  "& button": {
    [theme.breakpoints.down(FULL_APP_BAR_MIN_WIDTH)]: {
      padding: "2px",
    },
  },
}));

export const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  [theme.breakpoints.up(600)]: {
    minHeight: "58px",
  },
}));

export const IconButtonWrapper = styled(Box)(() => ({
  position: "relative",
  zIndex: 1,

  "& button, & a": {
    paddingLeft: `${NAV_ITEM_PADDING_X}px`,
    paddingRight: `${NAV_ITEM_PADDING_X}px`,
  },
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: `${NAV_ICON_GAP}px`,
  },
}));

export const EmptyBox = styled(Box)`
  flex-grow: 1;

  @media (min-width: 910px) {
    display: none;
  }
`;

export const DesktopOnly = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  marginLeft: "1rem",

  [theme.breakpoints.down(FULL_APP_BAR_MIN_WIDTH)]: {
    marginLeft: "0.5rem",
  },

  [theme.breakpoints.down(910)]: {
    display: "none",
  },
}));

export const MobileOnly = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down(910)]: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

export const DrawerContent = styled(Box)({
  width: "100vw",

  ".cl-userButtonAvatarBox": {
    width: "22px",
    height: "22px",
  },

  ".cl-userButton-root": {
    marginLeft: "-4px",
    marginRight: "8px",
  },
});

export const ChipBeta = styled(Chip)(({ theme }) => ({
  fontWeight: 400,
  borderRadius: 999,
  fontSize: 11,
  backgroundColor: "transparent",
  color: alpha(theme.palette.info.main, 0.75),
  border: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,

  [theme.breakpoints.down(910)]: {
    fontSize: "10px",
    height: "auto",
    padding: "2px 0",
  },
}));

export const SubscriptionBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 30px 0;
`;

export const IconButton = styled(MuiIconButton)<
  IconButtonProps & { href: string; target: string }
>(() => ({
  "& svg": {
    width: "20px",
    height: "20px",
  },
}));
